import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// ============================================
// Cell root
// ============================================
// 각 줄을 한 줄로 유지하고(줄바꿈 금지) 내용 폭만큼 가로로 늘어나게 한다.
// 컬럼이 넓어지면 테이블 컨테이너의 가로 스크롤로 처리된다(아래로 줄바꿈 안 함).
export const CellRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: 'max-content',
  whiteSpace: 'nowrap',
});

// ============================================
// Ticket line container
// ============================================
export const TicketLine = styled('div', {
  shouldForwardProp: prop => prop !== 'dimmed',
})(({ dimmed }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  flexWrap: 'nowrap',
  whiteSpace: 'nowrap',
  padding: '4px 8px',
  borderRadius: '6px',
  opacity: dimmed ? 0.55 : 1,
}));

// ============================================
// Chips
// ============================================
// 아웃라인 상태 칩: 배경 없이 테두리·글자에만 상태색을 준다. (상태만 노출)
export const StatusChip = styled('span', {
  shouldForwardProp: prop => prop !== 'fg',
})(({ fg }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '3px',
  backgroundColor: `${fg}18`,
  color: fg,
  border: `1px solid ${fg}40`,
  fontSize: '11px',
  fontWeight: 700,
  padding: '2px 8px',
  borderRadius: '20px',
  whiteSpace: 'nowrap',
  '&::before': {
    content: '""',
    width: '5px',
    height: '5px',
    borderRadius: '50%',
    backgroundColor: fg,
    flexShrink: 0,
  },
}));

// 판매지점 칩(#73 다지점 공유). 다른 지점에서 팔린 상품일 때만 붙는다.
// 상태 칩과 헷갈리지 않게 상태색을 쓰지 않고 점(dot)도 없는 중립 회색 톤으로 둔다.

// ============================================
// Text
// ============================================
export const ProductName = styled('span')({
  fontSize: '13.5px',
  fontWeight: 600,
  color: '#26313C',
  whiteSpace: 'nowrap',
});

export const MetaText = styled('span')({
  fontSize: '13px',
  color: '#8A939C',
  whiteSpace: 'nowrap',
});

export const PeriodText = styled('span')({
  fontSize: '13px',
  color: '#5B6470',
  whiteSpace: 'nowrap',
});

export const DdayText = styled('span')({
  fontSize: '12px',
  fontWeight: 800,
  color: '#C46A00',
  whiteSpace: 'nowrap',
});

// 기존 [중지 ...] 텍스트에 쓰던 강조색(#ff0000) 재사용
export const StoppedNote = styled('span')({
  fontSize: '13px',
  color: '#ff0000',
  whiteSpace: 'nowrap',
});

// 기간·D-day·중지안내를 한 덩어리로 묶는다. 실제 컬럼 폭(약 520px)에서는 줄이 접히는데,
// 묶지 않으면 'D-30'만 다음 줄에 홀로 떨어져 기간과 분리돼 보인다.
export const PeriodGroup = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '6px',
  whiteSpace: 'nowrap',
});

// ============================================
// Expired toggle
// ============================================
export const ExpiredToggle = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '3px',
  fontSize: '12px',
  fontWeight: 500,
  color: '#777',
  textDecoration: 'underline',
  marginTop: '4px',
  paddingLeft: '8px',
  cursor: 'pointer',
  userSelect: 'none',
  width: 'fit-content',
  '&:hover': {
    color: '#666',
  },
});

// 더보기/접기 방향 표시 화살표
export const ToggleChevron = styled('span')({
  fontSize: '9px',
  lineHeight: 1,
});
